import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** @see docs/API_SYSTEM_ACCESS.md */
export async function fetchRoleDetail(id) {
  const { data: raw } = await request.get(`/system/role/${id}`);
  return parseVer4DetailResponse(raw);
}
